// extracted by mini-css-extract-plugin
module.exports = {"main-dark":"SocialIcons_main-dark__wcR93","main-light":"SocialIcons_main-light__JQynU","search-fade-in":"SocialIcons_search-fade-in__W6Rpa"};